import { render } from "./BrandBallguide.vue?vue&type=template&id=1985a06e"
import script from "./BrandBallguide.vue?vue&type=script&lang=ts"
export * from "./BrandBallguide.vue?vue&type=script&lang=ts"

import "./BrandBallguide.vue?vue&type=style&index=0&id=1985a06e&lang=scss"
script.render = render

export default script